// extracted by mini-css-extract-plugin
module.exports = {"root":"Category-module--root--nFDMS","container":"Category-module--container--1hZGn","category":"Category-module--category--20ZuB"};